export default __webpack_public_path__ + "static/media/logo-us-Janie-Jack.6f6299d6.svg";